import { call, put, takeLatest } from 'redux-saga/effects';

import { getThemes } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const response = yield call(getThemes, action.payload);
  yield put(
    response.isOk ? requestSuccess(response.data, action.payload) : requestFailure(response.error),
  );
}

export default function* appealThemesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
